/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect,useRef,useCallback} from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
// import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import Link from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
// import Menu from '@mui/joy/Menu';
// import MenuButton from '@mui/joy/MenuButton';
// import MenuItem from '@mui/joy/MenuItem';
// import Dropdown from '@mui/joy/Dropdown';
import { Modal } from '@mui/joy';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import CircularProgress from '@mui/joy/CircularProgress';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import axios from 'axios';

interface Part {
  number: string;
  number_new: string;
  name_eng: string;
  price_list: number;
  active: boolean;
  description: string;
}
interface Unit {
  id: number;
  model: string;
  name_eng: string;
  country: string;
}

interface PagedResult<T> {
  records: T[];
  total: number;
  size: number;
  current: number;
  pages: number;
}

interface BarcodeResponse<T> {
  code: number;
  msg: string;
  data: PagedResult<T>;
}

// function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

type Order = 'asc' | 'desc';


// function RowMenu({ onDetailClick }: { onDetailClick: () => void }) {
//   return (
//     <Dropdown>
//       <MenuButton
//         slots={{ root: IconButton }}
//         slotProps={{ root: { variant: 'plain', color: 'neutral', size: 'sm' } }}
//       >
//         <MoreHorizRoundedIcon />
//       </MenuButton>
//       <Menu size="sm" sx={{ minWidth: 140 }}>
//         <MenuItem onClick={onDetailClick}>Detail</MenuItem>
//         <Divider />
//         <MenuItem color="danger">Edit</MenuItem>
//       </Menu>
//     </Dropdown>
//   );
// }
export default function UnitTable() {
  const [units, setUnits] = useState<Unit[]>([]);
  const [allUsaUnits, setAllUsaUnits] = useState<Unit[]>([]); 
  const [currentParts, setCurrentParts] = useState<Part[]>([]);
  const [currentFilteredParts, setCurrentFilteredParts] = useState<Part[]>([]);
  const [currentModel, setCurrentModel] = useState<string>('');
  const [filter, setFilter] = useState('');
  const [nextPage, setNextPage] = useState<string | null>(null);
  const [prevPage, setPrevPage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);  
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [partsCache, setPartsCache] = useState<{[key: string]: Part[]}>({});
  const [apiCache, setApiCache] = useState<{[key: string]: PagedResult<Unit>}>({});

  // Use absolute barcode API URL so production does not depend on a dev proxy
  const apiUrl = 'https://barcode.atosausa.com/api';

  const fetUnits = useCallback(async (searchTerm: string = '', page: number = 1) => {
    const cacheKey = `${searchTerm}_${page}`;
    
    // Check cache first
    if (apiCache[cacheKey]) {
      const cachedData = apiCache[cacheKey];
      setUnits(cachedData.records);
      setAllUsaUnits(cachedData.records);
      setNextPage(cachedData.current < cachedData.pages ? String(cachedData.current + 1) : null);
      setPrevPage(cachedData.current > 1 ? String(cachedData.current - 1) : null);
      const total = cachedData.total;
      const pages = Math.ceil(total / 200);
      setTotalPages(pages);
      return;
    }
    /* -----change this to country=Mexico for Mexico units if needed----- */
    setLoading(true);
    try {
      const response = await axios.get<BarcodeResponse<any>>(`${apiUrl}/units`, { 
        params: {
          pageNum: page,
          pageSize: 200,
          country: 'USA',
          // Search by model only as requested
          model: searchTerm || undefined,
        },
        timeout: 10000,
      });

      const paged = response.data.data;

      const mappedUnits: Unit[] = paged.records.map((u: any) => ({
        id: u.id,
        model: u.model,
        name_eng: u.nameEng,
        country: u.country,
      }));

      // Cache the paged result using mapped units so subsequent reads
      // from cache have the same shape as the Unit type used in the UI.
      const pagedMapped: PagedResult<Unit> = {
        ...paged,
        records: mappedUnits,
      };

      setApiCache(prev => ({
        ...prev,
        [cacheKey]: pagedMapped,
      }));

      setUnits(mappedUnits);
      setAllUsaUnits(mappedUnits);
      setNextPage(paged.current < paged.pages ? String(paged.current + 1) : null);
      setPrevPage(paged.current > 1 ? String(paged.current - 1) : null);

      // Calculate total pages based on API response
      const total = paged.total;
      const pages = Math.ceil(total / 200);
      setTotalPages(pages);

    } catch (error) {
      console.error('Error fetching units:', error);
    } finally {
      setLoading(false);
    }
  },
    [apiCache, apiUrl] // 
);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetUnits(searchTerm, currentPage);
    }, 300); // Debounce search for 300ms

    return () => clearTimeout(timeoutId);
  }, [searchTerm, currentPage, fetUnits]);

  const handlePagination = (page: number) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase(); // Convert filter text to lowercase for case-insensitive matching
    
    setFilter(value);
    if (value === "") {
      // If the filter is cleared, show all parts for this unit again
      setCurrentFilteredParts(currentParts);
    } else {
    const filteredParts = currentParts.filter((row) => {
      return (
        row.number.toLowerCase().includes(value) ||
        row.number_new.toLowerCase().includes(value) ||
        row.name_eng.toLowerCase().includes(value) ||
        row.description.toLowerCase().includes(value) ||
        (`$${row.price_list}`.includes(value))
      );
    });
    
    setCurrentFilteredParts(filteredParts); // Set the filtered parts
  }
  };
  const handleDetailClick = async (row: any) => {
    const unitId = row.id;
    const cacheKey = String(unitId);

    // Check if parts are already cached for this unit
    if (partsCache[cacheKey]) {
      setCurrentParts(partsCache[cacheKey]);
      setCurrentFilteredParts(partsCache[cacheKey]);
      setFilter('');
      setCurrentModel((row.model || ' ') + ' Related Parts');
      setIsDialogOpen(true);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/part-units/p/${unitId}`);
      const parts: Part[] = (response.data.results || []).map((p: any) => ({
        number: p.number,
        number_new: p.numberNew,
        name_eng: p.nameEng,
        price_list: p.priceList ?? 0,
        active: p.active,
        description: p.description || '',
      }));

      // Cache the results
      setPartsCache(prev => ({
        ...prev,
        [cacheKey]: parts,
      }));

      setCurrentParts(parts);
      setCurrentFilteredParts(parts);
    } catch (error) {
      console.error('Error fetching part details:', error);
      setCurrentParts([]);
      setCurrentFilteredParts([]);
    } finally {
      setLoading(false);
    }
    
    setFilter('');
    setCurrentModel((row.model || ' ') + ' Related Parts');
    setIsDialogOpen(true);
  };

  const handleSearch = (query: string) => {
    setSearchTerm(query);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };
  const getPaginationRange = () => {
    const range: number[] = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    return range;
  };
  const [order, setOrder] = React.useState<Order>('desc');
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  return (
    <React.Fragment>
      <Sheet
        className="SearchAndFilters-mobile"
        sx={{ display: { xs: 'flex', sm: 'none' }, my: 1, gap: 1 }}
      >
        <Input
          size="sm"
          placeholder="Search"
          startDecorator={<SearchIcon />}
          slotProps={{
            input: {
              ref: searchInputRef,
            },
          }}
          //ref={searchInputRef}
          // value={search}
          // onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const value = (e.target as HTMLInputElement).value;
              handleSearch(value); // Trigger search when Enter is pressed
            }
          }}
          sx={{ flexGrow: 1,maxWidth: '200px' }}
        />
        <IconButton
          size="sm"
          variant="outlined"
          color="neutral"
          onClick={() => {
            if (searchInputRef.current) {
              //console.log(searchInputRef.current); // Log the input element to check if it's correct
              const value = searchInputRef.current.value; // 获取输入框的值
              //console.log(value);
              handleSearch(value); // 调用搜索函数
            }
          }}
          
        >
          <FilterAltIcon />
        </IconButton>
      </Sheet>
      <Box
        className="SearchAndFilters-tabletUp"
        sx={{
          borderRadius: 'sm',
          py: 2,
          display: { xs: 'none', sm: 'flex' },
          flexWrap: 'wrap',
          gap: 1.5,
          maxWidth: '250px',
          '& > *': {
            minWidth: { xs: '120px', md: '160px' },
          },
        }}
      >
        <FormControl sx={{ flex: 1 }} size="sm">
          <Input 
            size="sm" 
            placeholder="Search" 
            startDecorator={<SearchIcon />} 
            // value={search}
            // onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                const value = (e.target as HTMLInputElement).value;
                handleSearch(value); // Trigger search when Enter is pressed
              }
            }}
          />
        </FormControl>
        {/* {renderFilters()} */}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography level="body-md" sx={{ fontWeight: 'md' }}>
          Total Units: {allUsaUnits.length} (Showing up to 50 on page {currentPage})
        </Typography>
      </Box>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: 'flex', sm: 'initial' },
          width: '100%',
          borderRadius: 'sm',
          flexShrink: 1,
          overflow: 'auto',
          minHeight: 0,
        }}
      >
        {loading ? (
          <Box
          sx={{
            position: 'fixed',  // 使用固定定位，使其固定在视口内
            top: '50%',  // 垂直居中
            left: '50%',  // 水平居中
            transform: 'translate(-50%, -50%)',  // 使用 transform 来精确居中
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,  // 确保加载指示器在其他内容之上
          }}
        >
            <CircularProgress />
          </Box>
        ) : (
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
            '--Table-headerUnderlineThickness': '1px',
            '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
            '--TableCell-paddingY': '4px',
            '--TableCell-paddingX': '8px',
          }}
        >
          <thead>
            <tr>
              <th style={{ width: 100, padding: '12px 6px' }}>
                <Link
                  underline="none"
                  color="primary"
                  component="button"
                  onClick={() => setOrder(order === 'asc' ? 'desc' : 'asc')}
                  endDecorator={<ArrowDropDownIcon />}
                  sx={[
                    {
                      fontWeight: 'lg',
                      '& svg': {
                        transition: '0.2s',
                        transform:
                          order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                      },
                    },
                    order === 'desc'
                      ? { '& svg': { transform: 'rotate(0deg)' } }
                      : { '& svg': { transform: 'rotate(180deg)' } },
                  ]}
                >
                  Model
                </Link>
              </th>
              <th style={{ width: 200, padding: '12px 6px' }}>Description</th>
              <th style={{ width: 60, padding: '12px 6px' }}> </th>
            </tr>
          </thead>
          <tbody>
            {units.map((row) => (
              <tr key={row.id}>
                <td>
                  <Typography level="body-xs">{row.model}</Typography>
                </td>
                <td>
                  <Typography level="body-xs">{row.name_eng}</Typography>
                </td>
                <td>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <IconButton
                      size="sm"
                      variant="plain"
                      color="neutral"
                      onClick={() => handleDetailClick(row)}
                      aria-label="Show related parts"
                      sx={{ p: 0.5 }}
                    >
                      <MoreHorizIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
          <Modal 
            open={isDialogOpen} 
            onClose={handleClose}
          >
            <Box
              sx={{
                position: 'fixed',
                top: '50%',
                left: {
                  xs: '50%',
                  md: 'calc(50% + (var(--Sidebar-width, 0px) / 2))',
                },
                transform: 'translate(-50%, -50%)',
                width: '100%', // Full width of the parent container
                maxWidth: 850, // Max width for larger screens
                height: 'auto', // Height adjusts based on content
                maxHeight: '90vh', // Limit height on smaller screens
                bgcolor: 'white',
                borderRadius: 2,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                overflow: 'auto', // Add scrolling when content overflows
                '@media (max-width: 600px)': {
                  maxWidth: '90%', // Limit width on smaller screens
                  maxHeight: '80vh', // Limit height on smaller screens
                },
              }}
            >
              <Typography level="h4" startDecorator={<i className="el-icon-document" />}>
                {currentModel}
              </Typography>
              <Box 
                component="form" 
                onSubmit={(e) => e.preventDefault()}
                sx={{
                  display: 'flex',
                  alignItems: 'center', // Align items horizontally
                  gap: 2, // Space between the label and input
                }}
              >
                <Typography>Filter</Typography>
                <Input
                  size="sm"
                  value={filter}
                  onChange={handleFilterChange}
                  placeholder="Search"
                />
              </Box>
              <Sheet
                className="PartTableContainer"
                variant="outlined"
                sx={{
                  display: { xs: 'flex', sm: 'initial' },
                  width: '100%',
                  borderRadius: 'sm',
                  flexShrink: 1,
                  overflow: 'auto',
                  minHeight: 0,
                }}
              >
                <Table
                  aria-labelledby="tableTitle"
                  stickyHeader
                  hoverRow
                  sx={{
                    '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
                    '--Table-headerUnderlineThickness': '1px',
                    '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
                    '--TableCell-paddingY': '4px',
                    '--TableCell-paddingX': '8px',
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 100, padding: '12px 6px' }}>Part Number</th>
                      <th style={{ width: 120, padding: '12px 6px' }}>New Number</th>
                      <th style={{ width: 180, padding: '12px 6px' }}>Name</th>
                      {/* <th style={{ width: 240, padding: '12px 6px' }}>Description</th> */}
                      <th style={{ width: 80, padding: '12px 6px' }}>List Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentFilteredParts.sort((a, b) => {
                      const numberA = a.number || '';
                      const numberB = b.number || '';
                      return numberA.localeCompare(numberB);
                    }).map((row) => (
                      <tr key={row.number}>
                        <td>
                          <Typography level="body-xs">{row.number}</Typography>
                        </td>
                        <td>
                          <Typography level="body-xs">{row.number_new}</Typography>
                        </td>
                        <td>
                          <Typography level="body-xs">{row.name_eng}</Typography>
                        </td>
                        {/* <td>
                          <Typography level="body-xs">{row.description}</Typography>
                        </td> */}
                        <td>
                          <Typography level="body-xs">${row.price_list}</Typography>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Sheet>
            </Box>
          </Modal>
        </Table>
        )}
      </Sheet>
      
      {/* Mobile Pagination */}
      <Box
        className="Pagination-mobile"
        sx={{
          pt: 2,
          gap: 1,
          display: {
            xs: 'flex',
            md: 'none',
          },
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          startDecorator={<KeyboardArrowLeftIcon />}
          onClick={() => handlePagination(currentPage - 1)}
          disabled={!prevPage}
        >
          Previous
        </Button>

        <Typography level="body-sm">
          Page {currentPage} of {totalPages}
        </Typography>

        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          endDecorator={<KeyboardArrowRightIcon />}
          onClick={() => handlePagination(currentPage + 1)}
          disabled={!nextPage}
        >
          Next
        </Button>
      </Box>

      {/* Desktop Pagination */}
      <Box
        className="Pagination-laptopUp"
        sx={{
          pt: 2,
          gap: 1,
          [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
          display: {
            xs: 'none',
            md: 'flex',
          },
        }}
      >
        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          startDecorator={<KeyboardArrowLeftIcon />}
          onClick={() => handlePagination(currentPage - 1)}
          disabled={!prevPage}
        >
          Previous
        </Button>

        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          {/* Dynamically render page numbers with ellipsis */}
          {totalPages > 0 ? (
            <>
              {currentPage > 3 && (
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={() => handlePagination(1)}
                  color="neutral"
                >
                  1
                </IconButton>
              )}

              {currentPage > 3 && <Typography sx={{ mx: 1 }}>...</Typography>}

              {getPaginationRange().map((pageNumber) => (
                <IconButton
                  key={pageNumber}
                  size="sm"
                  variant={pageNumber === currentPage ? 'solid' : 'outlined'}
                  onClick={() => handlePagination(pageNumber)}
                  color="neutral"
                >
                  {pageNumber}
                </IconButton>
              ))}

              {currentPage < totalPages - 2 && <Typography sx={{ mx: 1 }}>...</Typography>}

              {currentPage < totalPages - 2 && (
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={() => handlePagination(totalPages)}
                  color="neutral"
                >
                  {totalPages}
                </IconButton>
              )}
            </>
          ) : (
            <Typography>No result</Typography>
          )}
        </Box>

        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          endDecorator={<KeyboardArrowRightIcon />}
          onClick={() => handlePagination(currentPage + 1)}
          disabled={!nextPage}
        >
          Next
        </Button>
      </Box>
    </React.Fragment>
  );
}